import { useEffect, useState } from 'react';
import Lines from '../../components/Lines';
import programmesOfferred from "../Programmes.json";
import "./CurriculumAndSyllabus.scss";
import { Link } from 'react-router-dom';

const CurriculumAndSyllabus = () => {

    const [lineCount, setLineCount] = useState(getResponsiveLineCount());

    useEffect(() => {
        const handleResize = () => {
            setLineCount(getResponsiveLineCount());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function getResponsiveLineCount() {
        const width = window.innerWidth;
        if (width > 1800) return 70;
        if (width > 1700) return 65;
        if (width > 1600) return 60;
        if (width > 1400) return 55;
        if (width > 1300) return 50;
        if (width > 1200) return 50;
        if (width > 1100) return 50;
        if (width > 1000) return 50;
        if (width > 900) return 50;
        return 10;
    }

    return (
        <section className="curriculumPageMainContainer">
            <header>
                <h2>Curriculum & Syllabus</h2>
            </header>
            <div className="curriculumPageCoursesParent">
                <article className="curriculumFirstSection">
                    <h3>UG Programmes</h3>
                    <ul>
                        {programmesOfferred.ugProgrammes.map((course, index) => (
                            <li key={index}>
                                <Link className='curriculumandsyllabus'  to={course.routelink} target="_blank">{course.courseName}</Link>
                            </li>
                        ))}
                    </ul>
                </article>
                <span className="linesParent">
                    <Lines count={lineCount} color="white" rotateDeg={90} fontSize={2.1} spacing={2.5} skew={-40} />
                </span>
                <article className="curriculumSecondSection">
                    <div>
                        <h3>PG Programmes</h3>
                        <ul>
                            {programmesOfferred.pgProgrammes.map((course, index) => (
                                <li key={index}>
                                    <Link className='curriculumandsyllabus' to={course.routelink} target="_blank">{course.courseName}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </article>
            </div>
        </section>
    )
}

export default CurriculumAndSyllabus
